import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Elegant%20luxurious%20Asian%20aesthetic%20composition%20with%20golden%20accents%20and%20warm%20ambient%20lighting%2C%20silhouettes%20of%20traditional%20Asian%20architecture%20blending%20with%20modern%20minimalist%20design%20elements%2C%20soft%20gradient%20background%20from%20deep%20burgundy%20to%20warm%20cream%2C%20atmospheric%20and%20sophisticated%20mood&width=1920&height=1080&seq=hero-bg-01&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <p className="text-primary-300 text-sm md:text-base font-medium tracking-[0.3em] mb-4 animate-[fadeIn_1s_ease-out]">
          甄选亚洲顶级品牌 · 发现匠心之美
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6 max-w-3xl leading-tight animate-[fadeIn_1.2s_ease-out]">
          亚洲精品
          <span className="block text-2xl md:text-3xl lg:text-4xl font-normal text-primary-200 mt-3">
            汇聚东方美学，品味精致生活
          </span>
        </h1>
        <p className="text-white/70 text-sm md:text-base max-w-xl mb-8 animate-[fadeIn_1.4s_ease-out]">
          日韩、东南亚、中华顶级品牌与匠心工艺，每一件亚洲精品均经严格筛选，品质有保障
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 animate-[fadeIn_1.6s_ease-out]">
          <Link
            to="/category/fashion"
            className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            探索精品
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-white/30 text-white rounded-full text-sm font-medium hover:bg-white/10 hover:border-white/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解我们
          </Link>
        </div>
      </div>
    </section>
  );
}